import { get, post } from './';
import { getPublicShareToken } from './shareContext';

export const getExperiences = ({ filters, locale, skip = false }) => {
  if (skip) {
    return Promise.resolve(null);
  }

  return post(`api/v1/experiences/liste?locale=${locale ?? 'en'}`, filters);
};

// KD-3386: a DMC may stop distributing a product a TO has already sold. The API
// keeps serving such a product only to a caller that names the booking carrying
// it, and re-checks that the booking really belongs to the caller — so screens
// reading an experience FROM a booking have to say which one. Screens browsing
// the marketplace pass nothing and stay on the ordinary distribution check.
const withBookingScope = (url, bookingId) =>
  bookingId
    ? `${url}${url.includes('?') ? '&' : '?'}bookingId=${bookingId}`
    : url;

// KD-3825: a multi-destination trip holds partner products nobody distributes
// to the TO; the API serves them to the trip carrying them, so screens reading
// an experience from a trip name it.
export const getExperience = ({ experienceId, locale, bookingId, tripId }) => {
  if (!experienceId) {
    return Promise.resolve(null);
  }

  const shareToken = getPublicShareToken();
  if (shareToken) {
    return get(
      `api/internal/travel-diaries/${shareToken}/experiences/${experienceId}?locale=${locale ?? 'en'}`,
    );
  }

  return get(
    withBookingScope(
      `api/v1/experiences/${experienceId}?locale=${locale ?? 'en'}${
        tripId ? `&tripId=${tripId}` : ''
      }`,
      bookingId,
    ),
  );
};

// pax: the travelers each period's availabilityState is rated for.
export const getExperiencePeriods = ({ experienceId, bookingId, pax }) => {
  if (!experienceId) {
    return Promise.resolve(null);
  }

  const url = `api/v1/experiences/${experienceId}/periods`;
  return get(
    withBookingScope(pax === undefined ? url : `${url}?pax=${pax}`, bookingId),
  );
};

export const exportExperience = ({
  experienceId,
  locale,
  exportFormat,
  options,
  bookingId,
}) => {
  return post(
    withBookingScope(
      `api/v1/experiences/${experienceId}/export/${exportFormat}?locale=${locale ?? 'en'}`,
      bookingId,
    ),
    options,
    { responseType: 'blob' },
    false,
  );
};

export const bookExperiences = data => {
  return post(`/api/v1/experiences/book`, data);
};
